import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  background-color: #121E42;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HeaderTitle = styled.h2`
  color: white;
  font-size: 1.8rem;
  margin: 0;
  font-weight: 600;
`;

const Header: React.FC = () => {
  return (
    <HeaderContainer>
      <HeaderTitle>Grupo Nobre</HeaderTitle>
    </HeaderContainer>
  );
};

export default Header;
